// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#page-login .clave-unica img {\n  display: block;\n}[dir] #page-login .clave-unica img {\n  margin: 0 auto;\n  cursor: pointer;\n}", ""]);
// Exports
module.exports = exports;
